// Lecture d'un pipeline de prospection : étapes, retards de relance et
// regroupement par pays. Fonctions pures, sans dépendance React.

export const PROSPECT_STAGES = [
  { key: 'new', fr: 'Nouveau', en: 'New' },
  { key: 'contacted', fr: 'Contacté', en: 'Contacted' },
  { key: 'demo_done', fr: 'Démo faite', en: 'Demo done' },
  { key: 'trial', fr: 'Essai', en: 'Trial' },
  { key: 'won', fr: 'Client', en: 'Won' },
  { key: 'lost', fr: 'Perdu', en: 'Lost' },
];

// Un dossier gagné ou perdu ne se relance plus.
export const CLOSED_STAGES = ['won', 'lost'];

export const UNQUALIFIED_COUNTRY = 'À qualifier';

export const stageLabel = (key, language) => {
  const stage = PROSPECT_STAGES.find((s) => s.key === key);
  return stage ? (language === 'en' ? stage.en : stage.fr) : key;
};

export function isOverdue(prospect, now = new Date()) {
  if (!prospect || CLOSED_STAGES.includes(prospect.stage)) return false;
  if (!prospect.next_action_date) return false;
  const due = new Date(prospect.next_action_date);
  if (Number.isNaN(due.getTime())) return false;
  return due < now;
}

export function countByStage(prospects = []) {
  const counts = Object.fromEntries(PROSPECT_STAGES.map((s) => [s.key, 0]));
  prospects.forEach((prospect) => {
    const stage = prospect?.stage;
    if (stage in counts) counts[stage] += 1;
  });
  return counts;
}

/**
 * Un groupe par pays, du marché le plus fourni au moins fourni. Les dossiers
 * dont le pays reste à qualifier ferment la liste : ce sont des demandes
 * publiques pas encore triées, pas un marché.
 */
export function groupByCountry(prospects = [], now = new Date()) {
  const groups = new Map();

  prospects.forEach((prospect) => {
    const country = prospect?.country || UNQUALIFIED_COUNTRY;
    if (!groups.has(country)) {
      groups.set(country, { country, prospects: [], total: 0, overdue: 0 });
    }
    const group = groups.get(country);
    group.prospects.push(prospect);
    group.total += 1;
    if (isOverdue(prospect, now)) group.overdue += 1;
  });

  return [...groups.values()]
    .map((group) => ({ ...group, stages: countByStage(group.prospects) }))
    .sort((a, b) => {
      const aLast = a.country === UNQUALIFIED_COUNTRY;
      const bLast = b.country === UNQUALIFIED_COUNTRY;
      if (aLast !== bLast) return aLast ? 1 : -1;
      if (b.total !== a.total) return b.total - a.total;
      return a.country.localeCompare(b.country);
    });
}
